//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The type of change that will trigger the criteria to match. */
export const EntityChangeSimpleChangeType = {
    /**
     * The criteria will match if the specified property has changed its
     * value in any way. The OriginalValue and UpdatedValue properties
     * are ignored.
     */
    AnyChange: 0,

    /**
     * The criteria will match if the new value is equal to the
     * UpdatedValue property. The OriginalValue property is ignored.
     * ignored. This does not require that the value has changed.
     */
    HasSpecificValue: 1,

    /**
     * The criteria will match if the old value is equal to the OriginalValue
     * property and the property has been changed to a different value. The
     * UpdatedValue property is ignored. Will not match if the entity is being
     * added or deleted.
     */
    ChangedFromValue: 2,

    /**
     * The criteria will match if the new value is equal to the UpdatedValue
     * property and the property has been changed from a different value. The
     * OriginalValue property is ignored. Will not match if the entity is being
     * added or deleted.
     */
    ChangedToValue: 3,

    /**
     * The criteria will match if the old value is equal to the OriginalValue
     * property and the new/current value is equal to the UpdatedValue
     * property. This requires that the property value has actually been
     * changed. Will not match if the entity is being added or deleted.
     */
    ChangedFromValueToValue: 4
} as const;

/** The type of change that will trigger the criteria to match. */
export const EntityChangeSimpleChangeTypeDescription: Record<number, string> = {
    0: "Any Change",

    1: "Has Specific Value",

    2: "Changed From Value",

    3: "Changed To Value",

    4: "Changed From Value To Value"
};

/** The type of change that will trigger the criteria to match. */
export type EntityChangeSimpleChangeType = typeof EntityChangeSimpleChangeType[keyof typeof EntityChangeSimpleChangeType];
